import { ChartBinSize, ChartDefinition, ChartGroupByMode, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';
import { Application, Feature } from '@frontend/functionality/types';

import { PACKAGES_VOLUME_CHART_ENDPOINT } from '../package-chart-endpoints';

export const VENDING_PACKAGE_VOLUME_BY_PRODUCT_MONTHLY_LIST_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.VENDING_PACKAGE_VOLUME_BY_PRODUCT_MONTHLY_LIST,
    chartType: ChartRendererType.LIST,
    endpoint: PACKAGES_VOLUME_CHART_ENDPOINT,
    filters: [
        { key: ChartQueryParam.APPLICATION, value: Application.VENDING },
        { key: ChartQueryParam.FEATURE, value: Feature.OUTBOUND_TRANSACTION },
        { key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.MONTH }
    ],
    groupBy: ChartQueryParam.PRODUCT_ID,
    groupByMode: ChartGroupByMode.VALUE
};
